import { Component } from '@angular/core';

@Component({
  selector: 'app-cash-payments-learn-more',
  templateUrl: './cash-payments-learn-more.component.html',
  styleUrls: ['./cash-payments-learn-more.component.scss']
})
export class CashPaymentsLearnMoreComponent {
}
